import { useState } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PhoneCallbackOutlinedIcon from "@mui/icons-material/PhoneCallbackOutlined";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  name: string;
  onPullForward: () => void;
  onContactAttempt: () => void;
  onDelete: () => void;
  isBusy: boolean;
}

export function PriorityRequestRowMenu({ name, onPullForward, onContactAttempt, onDelete, isBusy }: Props) {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  function handleSelect(action: () => void) {
    setAnchor(null);
    action();
  }

  return (
    <>
      <IconButton
        size="small"
        disabled={isBusy}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
        aria-label={t("priorityRequests.menu.ariaLabel", { name })}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(event) => event.stopPropagation()}
      >
        <MenuItem onClick={() => handleSelect(onPullForward)}>
          <ListItemIcon>
            <EventAvailableOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("priorityRequests.menu.pullForward")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelect(onContactAttempt)}>
          <ListItemIcon>
            <PhoneCallbackOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("priorityRequests.menu.contactAttempt")}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleSelect(onDelete)}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>{t("priorityRequests.menu.delete")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
